<template>
  <div />
</template>
<script>
// @ is an alias to /src

export default {
  name: "AdminGroupsBinder",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {},
  mounted() {
    // Does document exist.
    this.$store.dispatch("loadGroups");
  },
  methods: {}
};
</script>
